<div class="container-md p-md-0">
  <ts-asset-selection
    header="{{ 'my_eligible_devices' | translate }}"
    no_asset_text="{{ 'no_eligible_devices' | translate }}"
    [asset_fields]="['imei', 'imei2', 'serial_number']"
    [existing_asset]="shopping_cart && shopping_cart.existing_asset"
    (asset_selection_emit)="selectAsset($event)"
  />
</div>
